module.exports = __webpack_public_path__ + "media/components/footer/static/surf__white-97a70190713a598787e76768b10bf0f7.svg";